import React, { useContext, useState, useEffect } from 'react'
import { useIntl } from 'react-intl'
import { SessionContext, AppContext } from 'contexts'
import { initialPage } from 'utilities/pagination'
import { createExcel } from 'utilities/excel'
import { filters, columns, handlers } from 'models/partList'
import { Button, Center, Link, Section, Table } from 'components/core'
import Page from 'components/Page'
import PartDrawer from 'views/PartDrawer'
import { MdFileUpload } from 'react-icons/md'
import PartImageDrawer from './PartImageDrawer'

export default () => {
  const { formatMessage: message } = useIntl()
  const session = useContext(SessionContext)
  const app = useContext(AppContext)
  const [state, setState] = useState([])
  const [filterValues, setFilterValues] = useState([])
  const [pagination, setPagination] = useState(initialPage())
  const [open, setOpen] = useState(false)
  const [value, setValue] = useState([])
  const [imageOpen, setImageOpen] = useState(false)
  const [images, setImages] = useState({})
  const { handleLoad, handleExport } = handlers({
    session,
    app,
    setState,
    setFilterValues,
    setPagination,
    message,
  })

  useEffect(() => {
    handleLoad()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleOpen = (item) => {
    setValue(item)
    setOpen(true)
  }

  const handleClose = () => {
    setOpen(false)
    setValue({})
  }

  const handleImageOpen = (item) => {
    setImages(item)
    setImageOpen(true)
  }

  const handleImageClose = () => {
    setImageOpen(false)
    setImages({})
  }

  return (
    <Page
      title="part.title.list"
      navId="partList"
      action={
        <Center>
          <Link
            mr={3}
            icon={<MdFileUpload />}
            text="btn.export"
            onClick={() => handleExport({ filterValues, createExcel })}
          />
          <Button
            variant="secondary"
            text="btn.add"
            onClick={() => handleOpen({})}
          />
        </Center>
      }
    >
      <Section>
        <Table
          columns={columns({
            session,
            app,
            message,
            action: { handleLoad, handleOpen, handleImageOpen },
          })}
          rows={state}
          filters={filters}
          filterValues={filterValues}
          pagination={pagination}
          onChange={handleLoad}
        />
      </Section>
      <PartDrawer
        open={open}
        value={value}
        action={{ handleLoad, handleClose }}
      />
      <PartImageDrawer
        open={imageOpen}
        value={images}
        action={{ handleClose: handleImageClose }}
      />
    </Page>
  )
}
